import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/api";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Nous écrire sur WhatsApp"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[#25D366] text-black font-display font-bold uppercase tracking-widest text-sm px-5 py-3.5 rounded-full shadow-[0_0_25px_rgba(37,211,102,0.4)] hover:scale-105 hover:shadow-[0_0_40px_rgba(37,211,102,0.6)] transition-[transform,box-shadow] duration-300"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">WhatsApp</span>
    </a>
  );
}
